<template>
	<div>
		<b-modal
			id="fieldObrigatorityModal"
			:title="generateTitleByStep"
			:ok-title="$t('buttons.save')"
			ok-variant="info"
			:cancel-title="$t('buttons.cancel')"
			cancel-variant="outline-info"
			size="xl"
			@ok="callbackOk"
		>
			<template #default>
				<div class="d-flex flex-column" style="margin: 0 1.5rem">
					<div v-for="section in fieldSections" :key="section.idTab" class="field-section">
						<p class="stepName text-center">{{ section.title }}</p>
						<b-row>
							<b-col cols="6">
								<div
									v-for="stepFields in section.leftColumnFields"
									:key="stepFields.idInviteField"
									class="field-group"
								>
									<p class="fieldTitle">
										{{ $t(`commons.integrationConsultations.${getFieldName(stepFields.idInviteField)}`) }}&nbsp;
									</p>
									<b-form-radio-group
										v-model="stepFields.visualizationType"
										class="radio-field"
										aria-label="Radio group for obrigatoriedade"
										@change="onObrigatorietyChange(stepFields)"
									>
										<b-form-radio v-for="option in fieldObrigatorityList" :key="option.id" :value="option.id">
											{{ option.name }}
										</b-form-radio>
									</b-form-radio-group>
								</div>
							</b-col>
							<b-col cols="6">
								<div
									v-for="stepFields in section.rightColumnFields"
									:key="stepFields.idInviteField"
									class="field-group"
								>
									<p class="fieldTitle">
										{{ $t(`commons.integrationConsultations.${getFieldName(stepFields.idInviteField)}`) }}&nbsp;
									</p>
									<b-form-radio-group
										v-model="stepFields.visualizationType"
										class="radio-field"
										aria-label="Radio group for obrigatoriedade"
										@change="onObrigatorietyChange(stepFields)"
									>
										<b-form-radio v-for="option in fieldObrigatorityList" :key="option.id" :value="option.id">
											{{ option.name }}
										</b-form-radio>
									</b-form-radio-group>
								</div>
							</b-col>
						</b-row>
					</div>
				</div>
			</template>
		</b-modal>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
	data() {
		return {
			idUser: null,
			idActor: null,
			inviteFields: [],
			fieldObrigatorityList: [
				{ id: 1, name: this.$t("modals.fieldObrigatorityModal.mandatory") },
				{ id: 2, name: this.$t("modals.fieldObrigatorityModal.disabled") },
				{ id: 3, name: this.$t("modals.fieldObrigatorityModal.optional") }
			],
			fieldTabs: [
				{ idTab: this.$InviteFieldTab.SUPPLIER_DETAILS, titleKey: "modals.fieldObrigatorityModal.title" },
				{ idTab: this.$InviteFieldTab.BANK_DATA, titleKey: "modals.fieldObrigatorityModal.bankData" }
			]
		};
	},
	props: {
		modalType: {
			type: String
		},
		actualStep: {
			type: Object,
			required: true
		}
	},
	computed: {
		...mapGetters(["workflowDetails"]),
		fieldSections() {
			const stepFields = this.actualStep?.stepFields ?? [];
			return this.fieldTabs
				.map((tab) => {
					const fields = stepFields.filter((sf) => this.getFieldTab(sf.idInviteField) === tab.idTab);
					const half = Math.ceil(fields.length / 2);
					return {
						idTab: tab.idTab,
						title: this.$t(tab.titleKey),
						leftColumnFields: fields.slice(0, half),
						rightColumnFields: fields.slice(half)
					};
				})
				.filter((section) => section.leftColumnFields.length || section.rightColumnFields.length);
		},
		generateTitleByStep() {
			return this.$t("modals.fieldObrigatorityModal.mandatoryFields", [this.actualStep?.name]);
		}
	},
	methods: {
		...mapActions(["getInviteFields"]),
		callbackOk() {
			this.actualStep.updatedStepFields = true;
		},
		setFieldObrigatorityProperties(dataObject) {
			const { stepFields } = dataObject;
			this.inviteFields.forEach((field) => {
				const matchedStepField = stepFields.find((sf) => sf.idInviteField == field.id);
				this.$set(field, "visualizationType", matchedStepField ? matchedStepField.visualizationType : null);
				if (matchedStepField) {
					field.visualizationType = matchedStepField.visualizationType;
				} else {
					field.visualizationType = null;
				}
			});
		},
		getFieldName(id) {
			const inviteField = this.inviteFields.find((field) => field.id === id);
			return inviteField.name;
		},
		getFieldTab(id) {
			const inviteField = this.inviteFields.find((field) => field.id === id);
			return inviteField ? inviteField.idTab : null;
		},
		getBankStepFieldByName(name) {
			return this.actualStep.stepFields.find((sf) => this.getFieldName(sf.idInviteField) === name);
		},
		obrigatorietyRank(value) {
			const { OBRIGATORY, OPTIONAL } = this.$StepFieldVisualizationType;
			if (value === OBRIGATORY) return 2;
			if (value === OPTIONAL) return 1;
			return 0;
		},
		showDependencyAlert(messageKey) {
			this.$bvModal.msgBoxOk(this.$t(messageKey), {
				title: this.$t("commons.attention"),
				okVariant: "info",
				okTitle: this.$t("buttons.ok"),
				footerClass: "border-top-0",
				centered: true
			});
		},
		onObrigatorietyChange(stepField) {
			const fieldName = this.getFieldName(stepField.idInviteField);
			const { OBRIGATORY, OPTIONAL, DISABLED } = this.$StepFieldVisualizationType;

			if (fieldName === "agency") {
				const agencyValue = stepField.visualizationType;
				if (agencyValue !== OBRIGATORY && agencyValue !== OPTIONAL) return;

				const bank = this.getBankStepFieldByName("bank");
				if (bank && bank.visualizationType === DISABLED) {
					bank.visualizationType = agencyValue;
					this.showDependencyAlert("modals.fieldObrigatorityModal.bankForcedByAgencyInfo");
				}
			} else if (fieldName === "bank") {
				const agency = this.getBankStepFieldByName("agency");
				if (agency && this.obrigatorietyRank(agency.visualizationType) > this.obrigatorietyRank(stepField.visualizationType)) {
					agency.visualizationType = stepField.visualizationType;
					this.showDependencyAlert("modals.fieldObrigatorityModal.agencyFollowedBankInfo");
				}
			}
		}
	},
	beforeMount() {
		this.getInviteFields()
			.then(({ inviteFields }) => {
				if (Array.isArray(inviteFields) && inviteFields.length > 0) {
					this.inviteFields = inviteFields.map((field) => ({
						...field,
						visualizationType: null
					}));
				} else {
					console.warn("Nenhum campo de convite foi retornado.");
					this.inviteFields = [];
				}
			})
			.catch((error) => {
				console.error("Erro ao buscar campos de convite:", error);
				this.inviteFields = [];
			});
	}
};
</script>

<style scoped>
.field-section:not(:last-child) {
	margin-bottom: 1.5rem;
	padding-bottom: 1.5rem;
	border-bottom: 1px solid #ededed;
}

.stepName {
	font-family: "Open Sans";
	font-style: normal;
	font-weight: 600;
	font-size: 1.4rem;
	color: #1c1637;
	padding-bottom: 1rem;
}

.field-group {
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-bottom: 0.75rem;
}

.fieldTitle {
	font-family: "Open Sans";
	font-style: normal;
	font-weight: 600;
	font-size: 0.8rem;
	color: #333;
	margin: 0;
	width: 110px;
	flex-shrink: 0;
	white-space: nowrap;
	line-height: 1.5rem;
}

.radio-field {
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
	white-space: nowrap;
	min-height: 1.5rem;
}

.radio-field >>> .custom-control {
	min-height: auto;
}

.radio-field >>> .custom-radio {
	width: 115px;
	margin-right: 0;
	padding-left: 1.75rem;
}

.radio-field >>> .custom-control-label {
	font-size: 0.8rem;
}

.b-row {
	margin: 0 -10px;
}

.b-col {
	padding: 0 10px;
}
</style>
